export const loanPaymentHeaders = {
  TransNo: 'Trans No',
  'Loan Type': 'Loan Type',
  'Payment Date': 'Payment Date',
  Curr: 'Currency',
  Amount: 'Amount',
  PayMode: 'Pay Mode',
  Purpose: 'Purpose',
  DeductFrom: 'Deduct From',
  Installments: 'No. of Inst.',
  'Outstanding Amt': 'Outstanding Amount',
};
